/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { createObservableDataAction, IAction, IActionContext, sendRequest } from '@msdyn365-commerce/core';

import { ReportReviewConcernInput } from './inputs/report-review-concern-input';

async function reportReviewConcern(input: ReportReviewConcernInput, ctx: IActionContext): Promise<boolean> {
    if (!inputIsValid(input)) {
        throw new Error(
            `[SubmitHelpfulnessVote] Invalid input. ReviewId=${input.reviewId},tenantId=${input.tenantId},locale= ${input.locale},`
        );
    }

    const requestUrl =
        `${input.serviceEndpoint}/v2.0/concerns/review/${input.reviewId}` + `?tenantId=${input.tenantId}` + `&locale=${input.locale}`;

    const requestBody = {
        concernCategory: input.concernCategory
    };

    const requestHeader = {
        headers: {
            Authorization: `id_token ${input.authToken}`
        }
    };

    return sendRequest<boolean>(requestUrl, 'post', requestBody, requestHeader)
        .then(response => {
            return response.status === 200 || response.status === 201;
        })
        .catch(error => {
            ctx.trace('[ReportReviewConcernInput] Failed to report a concern');
            ctx.telemetry.exception(error);
            ctx.telemetry.debug('[ReportReviewConcernInput] Failed to report a concern');
            return false;
        });
}

function inputIsValid(input: ReportReviewConcernInput): boolean {
    return input && input.reviewId.length > 0 && input.tenantId.length > 0 && input.locale.length > 0 && input.authToken.length > 0;
}

export const reportReviewConcernDataAction = createObservableDataAction({
    id: '@msdyn365-commerce-modules/ratings-reviews/report-review-concern',
    action: <IAction<boolean>>reportReviewConcern
});

export default reportReviewConcernDataAction;
